import React, { useEffect, useState } from "react";
import style from "../solo.module.sass";
import { Select, Input, Icon, Button, Tooltip } from 'antd';
import dragIcon from "../../../../../assets/svg/drag_icon.svg";
import _ from "lodash";
import CodeEditor from "../codeEditor/CodeEditor"
import { ReactSortable } from "react-sortablejs";
const { Option } = Select;

const Condition = (props: any) => {/* eslint-disable */
    const { elements, nodeDetail, widgetDrawer } = props;
    const [sortableOptions, setSortableOptions] = useState({
        animation: 150,
        fallbackOnBody: true,
        swapThreshold: 0.65,
        ghostClass: "ghost",
        group: "shared",
        disabled: false,
        handle: ".drag-handle"
    });
    const [conditionName, setConditionName]: any = useState("")
    const [spaceKeyPressed, setSpaceKeyPressed]: any = useState(false)
    const [reactSortableKey, setReactSortableKey]: any = useState(new Date().getTime());
    const [addHandle, setAddHandle]: any = useState(0);
    const [addCondition, setAddCondition]: any = useState([{
        id: "",
        expression: "",
        Name: "",
        linkNode: "",
        nameCheck: false,
        blocks: false,
        expand: false,
    }])
    const [nodes, setNodes]: any = useState(null)
    const [name, setName]: any = useState(null);
    const [conditionProperty, setConditionProperty]: any = useState({ nodeId: null })
    const [removeCondition, setRemoveCondition]: any = useState(0)
    const [removedLinkNode, setRemovedLinkNode]: any = useState(null);
    const [modalOpen, setmodelOpen]: any = useState(false)
    const [handleId, setHandleId]: any = useState(null)
    const [updatedId, setUpdatedId]: any = useState(null)
    const [showCheckIcon, setShowCheckIcon]: any = useState(false)
    const [showaddIcon, setShowAddIcon]: any = useState(false)
    const [value, setValue]: any = useState(null)
    const [showEdit, setshowEdit] = useState(true)
    const [toggle, setToggleEnable]: any = useState(false)
    const [expandAll, setExpandAll]: any = useState(false);
    const [disableExpand, setDisableExpand]: any = useState(true)
    const [removeValues, setRemoveValues]: any = useState(false)
    const [editEnable, setEditEnable]: any = useState(false)
    const [eventNameEmpty, setEventNameEmpty] = useState(false)

    useEffect(() => {
        let arr: any = []
        elements.forEach((e: any) => {
            if (e.data && e.data.type && e.data.type !== "start" && e.data.type !== "error" && e.id !== props.nodeDetail.id) {
                arr.push(e)
                setNodes(arr)
            }
        })
    }, [elements])

    useEffect(() => {
        if (value && value.length > 0) {
            setShowCheckIcon(true)
        } else {
            setShowCheckIcon(false)
        }
    }, [value])

    useEffect(() => {
        let arr: any = [];
        let obj: any = {};
        if (addCondition.length > 0) {
            const findSourceHandle = elements.map((el: any) => {
                if (el.hasOwnProperty("sourceHandle")) {
                    return { sourceHandle: el.sourceHandle, source: el.source, target: el.target };
                } else {
                    return ""
                }
            }).filter((el: any) => el)

            addCondition.forEach((el: any) => {
                const element = findSourceHandle.filter((element: any) => { return element.sourceHandle === el.id && element.source === nodeDetail.id })
                let findElement: any;
                if (element.length > 0) {
                    element.forEach((e: any) => {
                        findElement = elements.filter((el: any) => { return el.id === e.target && e.source === nodeDetail.id })
                    })
                }
                if (findElement && findElement.length > 0) {
                    obj = {
                        ...el,
                        linkNode: findElement[0].id
                    }
                    arr.push(obj);
                } else {
                    obj = {
                        ...el,
                        linkNode: findElement && findElement.length === 0 ? el.linknode : ""
                    }
                    arr.push(obj)
                }
            })
        }
        arr.length > 0 && setAddCondition(arr)
    }, [elements])

    useEffect(() => {
        if (nodeDetail && nodeDetail.data.propertyDetails) {
            if (nodeDetail.type === "condition") {
                if (nodeDetail.data.propertyDetails.condition) {
                    let arr: any = [];
                    let obj: any = {};
                    setConditionName(nodeDetail.data.propertyDetails.name)
                    setName(nodeDetail.data.propertyDetails.name);
                    setConditionName(nodeDetail.data.propertyDetails.name);
                    setDisableExpand(false)
                    for (const element of elements) {
                        for (const condition of nodeDetail.data.propertyDetails.condition) {
                            if (element.source === nodeDetail.id && element.sourceHandle === condition.id) {
                                const nextNode = elements.filter((el: any) => { return (element.target === el.id) })
                                obj = {
                                    id: condition.id,
                                    Name: condition.Name,
                                    expression: condition.expression,
                                    linkNode: element.target,
                                    blocks: condition.blocks,
                                    nameCheck: condition.nameCheck,
                                    expand: condition.expand && condition.expand
                                }
                                if (arr.length > 0) {
                                    if (!arr.some((element: any) => element.id === obj.id)) {
                                        arr.push(obj);
                                    } else if (element.source === nodeDetail.id && element.sourceHandle === condition.id && condition.linkNode === "") {
                                        let value = arr.filter((ele: any) => {
                                            return ele.id === condition.id
                                        })
                                        value.map((val: any) => {
                                            val.linkNode = element.target;
                                        })
                                    }
                                } else {
                                    arr.push(obj);
                                }
                            } else if (condition.linkNode === "" && element.source !== nodeDetail.id && element.sourceHandle === undefined) {
                                obj = {
                                    id: condition.id,
                                    Name: condition.Name,
                                    expression: condition.expression,
                                    linkNode: condition.linkNode,
                                    blocks: condition.blocks,
                                    nameCheck: condition.nameCheck,
                                    expand: condition.expand && condition.expand
                                }
                                if (arr.length > 0) {
                                    if (!arr.some((element: any) => element.id === obj.id)) {
                                        arr.push(obj);
                                    }
                                }
                                else {
                                    arr.push(obj);
                                }
                            } else {
                                const node = elements.filter((el: any) => { return nodeDetail.id === condition.linkNode })
                                obj = {
                                    id: condition.id,
                                    Name: condition.Name,
                                    expression: condition.expression,
                                    linkNode: node.length > 0 ? condition.linkNode : "",
                                    blocks: condition.blocks,
                                    nameCheck: condition.nameCheck,
                                    expand: condition.expand && condition.expand
                                }
                                if (arr.length > 0) {
                                    if (!arr.some((element: any) => element.id === obj.id)) {
                                        arr.push(obj);
                                    }
                                }
                                else {
                                    arr.push(obj);
                                }
                            }
                        }
                    }
                    arr.length && setAddCondition(arr)
                    setShowCheckIcon(true)
                    setRemoveValues(false)
                    setEditEnable(false)
                    setEventNameEmpty(false)
                    setShowAddIcon(true)
                } else {
                    if (nodeDetail.type === "condition") {
                        setName(nodeDetail.data.propertyDetails && nodeDetail.data.propertyDetails.name);
                        setConditionName(nodeDetail.data.propertyDetails && nodeDetail.data.propertyDetails.name);
                        let conditionData: any = []
                        let condition: any = {}
                        let node: any;
                        let id = 0;
                        nodeDetail.data.propertyDetails && nodeDetail.data.propertyDetails.conditions && nodeDetail.data.propertyDetails.conditions.map((c: any) => {
                            id = id + 1
                            elements.map((e: any) => {
                                if (c.next.type === "end") {
                                    if (e.data && e.data.type && (e.data.type === "stop" || e.data.type === "return")) {
                                        node = e.id;
                                    }
                                } else if (e.source === nodeDetail.id && e.sourceHandle === _.camelCase(c.name)) {
                                    const nextNode = elements.filter((el: any) => { return (e.target === el.id) })
                                    node = nextNode && nextNode[0].data && nextNode[0].data.propertyDetails && nextNode[0].data.propertyDetails.name || e.target;
                                }
                                return node
                            })
                            condition = {
                                ...condition,
                                id: _.camelCase(c.name),
                                expression: c.expr,
                                Name: c.name,
                                linkNode: node,
                                blocks: true,
                                nameCheck: false,
                                expand: false,
                            }
                            node = "";
                            return conditionData.push(condition)
                        })
                        if (conditionData) {
                            setRemoveValues(false)
                            setDisableExpand(false);
                            setEditEnable(false)
                            setAddCondition(conditionData)
                            setShowCheckIcon(false)
                            setShowAddIcon(true)
                            setEventNameEmpty(false)
                        }
                    }
                }
            }
        } else if (!nodeDetail.data.propertyDetails) {
            if (nodeDetail.type === "condition") {
                setName(nodeDetail.id);
                setConditionName(nodeDetail.id);
                setAddCondition([{
                    id: "default",
                    expression: "true",
                    Name: "Default",
                    linkNode: "",
                    blocks: true,
                    nameCheck: false,
                    expand: false
                }])
                setAddHandle(addHandle + 1);
                setShowAddIcon(true)
                setEditEnable(false)
                setEventNameEmpty(false)
                setRemoveValues(false)
                setshowEdit(true);
                setDisableExpand(false)
                setEditEnable(false)
            }
        }
    }, [nodeDetail.id, widgetDrawer])

    useEffect(() => {
        if (conditionName || name === "") {
            setConditionProperty({
                nodeId: props.nodeDetail.id,
                name: conditionName,
                idChange: false,
                condition: addCondition,
                type: "condition"
            })
        }
    }, [conditionName])


    useEffect(() => {
        if (addCondition.length > 0) {
            if (addCondition.every((eL: any) => eL.expand === true)) {
                setExpandAll(true)
            } else {
                setExpandAll(false)
            }
        }
    }, [addCondition])


    useEffect(() => {
        props.onUpdateProperties(conditionProperty)
    }, [conditionProperty])

    useEffect(() => {
        if (removeCondition > 0) {
            setConditionProperty({
                nodeId: nodeDetail.id,
                condition: addCondition,
                name: name,
                idChange: true,
                removedLinkNode: removedLinkNode,
                handleId: handleId
            })
        }
    }, [removeCondition])

    useEffect(() => {
        if (addHandle > 0) {
            if (!updatedId) {
                setConditionProperty({
                    nodeId: nodeDetail.id,
                    condition: addCondition,
                    name: name,
                    idChange: true,
                })
            } else if (updatedId) {
                setConditionProperty({
                    nodeId: props.nodeDetail.id,
                    condition: addCondition,
                    name: name,
                    idChange: true,
                    updatedId: updatedId && updatedId
                })
            }
        }
    }, [addHandle])

    const AddHandle = () => {
        const value = {
            id: "",
            expression: "",
            Name: "",
            linkNode: "",
            blocks: false,
            nameCheck: false,
            expand: false
        }
        setAddCondition((prevState: any) => [value, ...prevState]);
    }

    const handleExpression = (i: any, value: any) => {
        const values = [...addCondition];
        values[i].expression = value;
        setAddCondition(values);
    }

    const handleSpace = (e: any) => {
        if (e.keyCode === 32 || e.keyCode === 8) {
            setSpaceKeyPressed(true)
        } else {
            setSpaceKeyPressed(false)
        }
    };

    const handleName = (e: any, Index: any) => {
        const { value } = e.target;
        setValue(value);
        const Names = addCondition.map((el: any) => _.camelCase(el.Name));
        setEventNameEmpty(false)
        if (Names) {
            if (Names.splice(0, Names.length + 1).includes(_.camelCase(e.target.value)) && !spaceKeyPressed) {
                const val = [...addCondition]
                val[Index].nameCheck = true;
                val[Index].Name = e.target.value;
                setAddCondition(val)
                setShowCheckIcon(false)
            } else {
                const values = [...addCondition];
                values[Index].Name = e.target.value;
                values[Index].nameCheck = false;
                values[Index].id = _.camelCase(e.target.value)
                setAddCondition(values);
            }
        } else {
            const values = [...addCondition];
            values[Index].Name = e.target.value;
            values[Index].nameCheck = false;
            values[Index].id = _.camelCase(e.target.value)
            setAddCondition(values);
        }
    }

    const linkNode = (e: any, Index: any) => {
        const values = [...addCondition];
        values[Index].linkNode = e;
        setAddCondition(values);
    }


    const handleRemove = (i: any = null, id: any = null) => {
        if (i !== undefined && !id) {
            const values = [...addCondition];
            values.splice(i, 1);
            setAddCondition(values);
        } else if (i !== undefined && id) {
            addCondition.forEach((c: any) => {
                if (c.id === id) {
                    setHandleId(c.id)
                    setRemovedLinkNode(c.linkNode)
                }
            })
            setAddCondition((prevState: any) => prevState.filter((i: any) => { return i.id !== id }))
            setRemoveCondition(removeCondition + 1);
        }
    }

    const findhandleId = (i: any, id: any) => {
        let updatedId = addCondition.filter((m: any) => {
            return (m.id === id);
        })
        updatedId && updatedId.map((i: any) => {
            return setUpdatedId(i.id)
        })
    }

    const openModal = () => {
        setmodelOpen(true)
    }

    const closeModal = () => {
        setmodelOpen(false)
    }

    const renderCondition = (index: number, element: any, blocks: any, expand: any) => {
        const checkSpecialCharacter = /[!@#$%^&*~`()_+\-=\[\]{};':"\\|,.<>\/?]+/;
        return (
            <div key={index + 1} style={{ padding: "0 10px" }}>
                {!expand && blocks &&
                    <div className={style.collapsePanel} >
                        <div
                            style={{ display: "flex", flexDirection: "row" }}
                        >
                            {blocks && !props.lock && showaddIcon &&
                                <img
                                    className={element.Name === "Default" ? "filtered" : "drag-handle"}
                                    style={{ height: "25px", width: 10, cursor: "move" }}
                                    onClick={() => element.Name !== "Default" && setToggleEnable(true)}
                                    src={element.Name !== "Default" ? dragIcon : ""}
                                />}
                            <Tooltip title={element.Name}>
                                <div className={style.panelName}>
                                    {element.Name}
                                </div>
                            </Tooltip>
                        </div>
                        {!props.lock &&
                            <div style={{ display: "flex", alignItems: "center" }}>
                                {!removeValues && !editEnable && showaddIcon && <Icon
                                    type="edit"
                                    style={{ marginRight: "10px", fontSize: 15 }}
                                    onClick={() => {
                                        setAddCondition(
                                            (condition: any) => condition.map((c: any) => {
                                                return c.id === element.id ? { ...element, blocks: false } : c
                                            }));
                                        findhandleId(index, element.id);
                                        setShowAddIcon(false)
                                        setShowCheckIcon(true)
                                        setshowEdit(false)
                                        setRemoveValues(true)
                                    }} />}
                                {element.Name !== "Default" && showaddIcon && <Icon
                                    type="delete"
                                    style={{ marginRight: "10px", fontSize: 15 }}
                                    onClick={() => handleRemove(index, element.id)}
                                ></Icon>}
                                {showaddIcon && <Icon
                                    style={{ fontSize: 15, marginRight: "10px" }}
                                    type="right"
                                    onClick={() => {
                                        setAddCondition(
                                            (condition: any) => condition.map((c: any) => {
                                                return c.id === element.id ? { ...element, expand: true } : c
                                            }))

                                    }} >
                                </Icon>}
                            </div>}
                    </div>}

                {(!blocks || expand) &&
                    <div
                        style={{
                            border: (expand || expandAll || !showEdit) ? "1px solid #CAD5E9" : "",
                            background: (expand || expandAll || !showEdit) ? "#FFFFFF 0% 0% no-repeat padding-box" : "",
                            boxShadow: (expand || expandAll || !showEdit) && "0px 3px 14px #CAD5E983",
                            marginTop: "20px",
                            borderRadius: "5px"
                        }}>
                        {(expand || expandAll || !showEdit && !props.lock) &&
                            <div style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                padding: (expand || expandAll || !showEdit) ? "0px 10px" : "0px 20px",
                                position: (expand || expandAll || !showEdit) && "relative",
                                marginTop: (expand || expandAll || !showEdit) && "10px"
                            }}>
                                {!props.lock && <img
                                    className="drag-handle"
                                    style={{ height: "25px", width: 10, cursor: "move" }}
                                    onClick={() => showaddIcon && element.Name !== "Default" && setToggleEnable(true)}
                                    src={element.Name !== "Default" ? dragIcon : ""}
                                />}
                                {!props.lock && <div>
                                    {!removeValues && showaddIcon && <Icon
                                        type="edit"
                                        style={{ marginRight: "10px", fontSize: 15 }}
                                        onClick={() => {
                                            setAddCondition(
                                                (condition: any) => condition.map((c: any) => {
                                                    return c.id === element.id ? { ...element, blocks: false } : c
                                                }));
                                            findhandleId(index, element.id);
                                            setShowAddIcon(false)
                                            setShowCheckIcon(true)
                                            setshowEdit(false)
                                            setRemoveValues(true)
                                        }}
                                    />}
                                    {element.Name !== "Default" && showaddIcon && <Icon
                                        type="delete"
                                        style={{ marginRight: "10px", fontSize: 15 }}
                                        onClick={() => handleRemove(index, element.id)}
                                    ></Icon>}
                                    {<Icon
                                        style={{ fontSize: 15, marginRight: "10px" }}
                                        type="down"
                                        onClick={() => {
                                            setAddCondition(
                                                (condition: any) => condition.map((c: any) => {
                                                    return c.id === element.id && showaddIcon ? { ...element, expand: false } : c
                                                }))
                                        }} >
                                    </Icon>}
                                </div>}
                            </div>}
                        <div
                            style={{
                                border: ((!expand && !expandAll && showEdit)) ? "1px dashed #0F66C8" : "",
                                borderRadius: "8px",
                                padding: (expand || !expandAll && showEdit) ? 10 : !showEdit ? 10 : 0,
                                margin: ((!expand || !expandAll) && !blocks) ? 5 : 0
                            }}>
                            <div
                                key={index}
                                className={style.conditionInput}
                                style={{
                                    borderBottom: (!expand || !expandAll) && blocks && "1px solid 000610",
                                    margin: !expand && blocks ? 13 : 0,
                                    height: "auto",
                                    padding: (expand || !expandAll) ? "0 10px" : "0 15px",
                                    boxSizing: "border-box",
                                }}>

                                <div
                                    className={style.label}
                                    style={{ color: "#3c434a" }}
                                >
                                    <label >Condition Name</label>
                                </div>
                                <Input
                                    onKeyDown={handleSpace}
                                    disabled={blocks || props.lock || element.Name === "Default"}
                                    style={{
                                        width: "100%",
                                        outline: "none",
                                        height: "44px",
                                        color: "#000610",
                                        fontSize: 15,
                                        border: "1px solid #909BAD"
                                    }}
                                    placeholder="Enter Condition Name"
                                    value={element.Name || ""}
                                    onChange={(e) => { !checkSpecialCharacter.test(e.target.value) && handleName(e, index) }}
                                />
                                {(element.nameCheck || eventNameEmpty) &&
                                    <p style={{
                                        color: "#FF0000",
                                        opacity: element.nameCheck || eventNameEmpty ? 1 : 0,
                                        position: "relative",
                                        top: '15px',
                                        textAlign: "center"
                                    }}>{eventNameEmpty ? "Name shouldn't be empty" : "Name already exist"}</p>}

                                {element.Name !== "Default" && <div className={style.label} style={{ color: "#3c434a" }}>
                                    <label >Expression</label>
                                </div>}
                                {element.Name !== "Default" && <Input
                                    disabled={element.Name === "Default" || blocks || props.lock}
                                    style={{
                                        width: "100%",
                                        height: "44px",
                                        fontSize: "15px",
                                        cursor: element.Name === "Default" || blocks || props.lock ? "not allowed" : "pointer",
                                        color: "#000610",
                                        border: "1px solid #909BAD"
                                    }}
                                    autoComplete="off"
                                    onClick={() => { element.Name !== "Default" && openModal(); }}
                                    placeholder="Add Expression"
                                    value={element.expression || undefined}
                                />}
                                {modalOpen && !blocks && !props.lock &&
                                    <CodeEditor
                                        id={index}
                                        values={element.expression}
                                        handleExpression={handleExpression}
                                        close={closeModal}
                                    />}
                                <div
                                    className={style.label}
                                    style={{ color: "#3c434a" }}
                                >
                                    <label >Next Node</label>
                                </div>
                                <Select
                                    showSearch
                                    suffixIcon={<Icon style={{ fontSize: "20px", margin: -5 }} type="caret-down" />}
                                    disabled={blocks || props.lock}
                                    value={element.linkNode || undefined}
                                    placeholder="Select the next node"
                                    optionLabelProp="label"
                                    style={{
                                        width: "100%",
                                        borderRadius: 8,
                                        color: "#000610",
                                        fontSize: 15
                                    }}
                                    mode="default"
                                    size="large"
                                    onChange={(e: any) => { linkNode(e, index) }}
                                    filterOption={(input, option: any) => {
                                        return (option && option.props)
                                            ?
                                            option.props.label.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            : false
                                    }}
                                >
                                    {nodes && nodes.map((el: any) => {
                                        return <Option
                                            key={el.id}
                                            value={el.id}
                                            label={el && el.data && el.data.propertyDetails && el.data.propertyDetails && el.data.propertyDetails.name || el.id}
                                        >
                                            <div
                                                style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                <div
                                                    style={{ display: "flex", flexDirection: "row" }}>
                                                    <img alt="icons" src={el.data.icon} />
                                                    <p
                                                        style={{
                                                            marginLeft: "8px",
                                                            marginTop: "15px",
                                                            color: el.id === element.linkNode ? "#0F66C8" : "#000610"
                                                        }}
                                                    >
                                                        {el && el.data && el.data.propertyDetails && el.data.propertyDetails && el.data.propertyDetails.name || el.id}
                                                    </p>
                                                </div>
                                                {el.id === element.linkNode &&
                                                    < Icon type="check" style={{ color: "#0F66C8" }} />}
                                            </div>
                                        </Option>
                                    })}
                                </Select>
                                <div style={{ display: "flex", flexDirection: "row", marginTop: 15, justifyContent: "flex-end" }}>
                                    {!blocks && !props.lock &&
                                        <Button
                                            style={{ width: "30%", marginRight: showCheckIcon ? "15px" : "0px" }}
                                            onClick={() => {
                                                let findCondition = nodeDetail?.data?.propertyDetails?.conditions ? nodeDetail?.data?.propertyDetails?.conditions : nodeDetail?.data?.propertyDetails?.condition
                                                showEdit ?
                                                    handleRemove(index, element.id && element.id) : element.id &&
                                                    setAddCondition(findCondition.map((c: any) => {
                                                        return { ...c, Name: c.name || c.Name, id: c.name || c.Name, blocks: true }
                                                    }));
                                                // showEdit ?
                                                //     handleRemove(index, element.id && element.id) : element.id &&
                                                //     setAddCondition((condition: any) => condition.map((c: any) => {
                                                //         return c.id.trim() === element.id.trim() ? { ...element, blocks: true } : c
                                                //     }));
                                                if(element.id){
                                                    setShowCheckIcon(false);
                                                    setShowAddIcon(true)
                                                    setDisableExpand(false)
                                                    setshowEdit(true);
                                                    setEditEnable(false)
                                                    setRemoveValues(false);
                                                    setEventNameEmpty(false)
                                                } else if (showEdit) {
                                                    setShowCheckIcon(false);
                                                    setShowAddIcon(true)
                                                    setDisableExpand(false)
                                                    setshowEdit(true);
                                                    setEditEnable(false)
                                                    setRemoveValues(false);
                                                    setEventNameEmpty(false)
                                                } else {
                                                    setEventNameEmpty(true)
                                                }
                                            }}
                                        >CANCEL</Button>}
                                    {(!blocks && !props.nameCheck && !props.lock && !element.nameCheck && showCheckIcon) &&
                                        <Button
                                            style={{ width: "30%", border: "none", backgroundColor: "#51808c" }}
                                            type="primary"
                                            onClick={() => {
                                                setAddCondition(
                                                    (condition: any) => {
                                                        const updatedCondition = condition.map((c: any) => {
                                                            return c.id === element.id ? { ...element, blocks: true, expand: false } : c
                                                        })
                                                        if (updatedCondition.length === 1) {
                                                            return updatedCondition;
                                                        }
                                                        if (showEdit) {
                                                            const defaultCondtion = updatedCondition.filter((condition: any) => { return (condition.Name === "Default") })
                                                            const newUpdatedCondition = updatedCondition.filter((condition: any) => { return (condition.Name !== "Default" && updatedCondition[0].id !== condition.id) })
                                                            return [...newUpdatedCondition, updatedCondition[0], ...defaultCondtion]
                                                        } else {
                                                            return updatedCondition
                                                        }
                                                    });
                                                setAddHandle(addHandle + 1);
                                                setShowAddIcon(true)
                                                setshowEdit(true);
                                                setDisableExpand(false)
                                                setEditEnable(false)
                                                if (showEdit) {
                                                    setUpdatedId(null)
                                                } else {
                                                    setRemoveValues(false)
                                                }
                                            }}
                                        >{showEdit ? "ADD" : "SAVE"}</Button>}
                                </div>
                            </div>
                        </div>
                    </div>}
            </div>)
    }

    useEffect(() => {
        setReactSortableKey(new Date().getTime());
        setSortableOptions({ ...sortableOptions, disabled: !toggle });
    }, [toggle]);

    return (
        <div style={{ height: window.innerHeight - 500 }}>
            <div className={style.conditionInput}>
                <div style={{ width: "100%" }}>
                    <div
                        className={style.label}
                        style={{ color: "#3c434a" }}>
                        <label >
                            Name
                        </label>
                    </div>

                    <Input
                        style={{
                            width: "100%",
                            height: "44px",
                            color: "#000610",
                            fontSize: 15,
                            border: props.nameCheck ? "1px solid #FF0000" : "1px solid #909BAD"
                        }}
                        placeholder="Enter Node Name"
                        value={name}
                        disabled={props.lock}
                        onChange={(e: any) => { setConditionName(e.target.value); setName(e.target.value); }}
                    />
                </div>
                {(props.nameCheck || !name) && <p style={{
                    color: "#FF0000",
                    opacity: props.nameCheck || !name ? 1 : 0,
                    position: "relative",
                    textAlign: "center",
                    margin: "5px",
                    fontSize: 14
                }}>{!name ? "Name shouldn't be empty" : "Name already exist"}</p>}
            </div>
            <div style={{ borderBottom: "1px solid rgb(202, 213, 233)", margin: "20px 20px" }}></div>
            <div style={{ display: "flex", justifyContent: "space-between", padding: "0px 10px" }}>
                {expandAll ?
                    <button
                        //disabled={!disableExpand}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "0px 14px",
                            borderRadius: 22,
                            border: "none",
                            outline: "none",
                            width: "35%",
                            cursor: "pointer",
                            background: "#F5F7FB 0% 0% no-repeat padding-box"
                        }}
                        onClick={() => {
                            !disableExpand && setAddCondition((prevState: any) => prevState.map((el: any) => ({
                                ...el,
                                expand: false
                            })))
                            !disableExpand && setExpandAll(false)
                        }}
                    >
                        <Icon style={{ fontSize: 15 }} type="folder" />
                        Collapse All
                    </button> :
                    <button
                        //disabled={}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "0px 16px",
                            borderRadius: 22,
                            border: "none",
                            outline: "none",
                            width: "35%",
                            cursor: "pointer",
                            background: "#F5F7FB 0% 0% no-repeat padding-box"
                        }}
                        onClick={() => {
                            !disableExpand && showaddIcon && setAddCondition((prevState: any) => prevState.map((el: any) => ({
                                ...el,
                                expand: true
                            })))
                            !disableExpand && showaddIcon && setExpandAll(true)
                        }}
                    >
                        <Icon style={{ fontSize: 15 }} type="folder-open" />
                        Expand All
                    </button>}
                <Button
                    style={{ borderRadius: 22, backgroundColor: "#51808c", color: "white", border: "none", outline: "none" }}
                    disabled={props.lock || !showaddIcon || expandAll || props.nameCheck}
                    // icon="folder-add"
                    onClick={() => {
                        if (!props.lock) {
                            AddHandle();
                            setShowCheckIcon(false);
                            setShowAddIcon(false);
                            setDisableExpand(true);
                            setEditEnable(true);
                        }
                    }}
                    type="primary"
                >Add condition
                </Button>
            </div>
            <div
                style={{ overflow: "auto", maxHeight: window.innerHeight - 360, border: "none", marginTop: "10px" }}>
                <ReactSortable list={addCondition} key={reactSortableKey} setList={(state: any) => {
                    const defaultValue = state.filter((value: any) => { return (value.Name === "Default") });
                    const other = state.filter((value: any) => { return (value.Name !== "Default") })
                    setAddCondition([...other, ...defaultValue])
                }} {...sortableOptions} onEnd={() => { setAddHandle(addHandle + 1) }}>
                    {addCondition.map((element: any, index: any) => {
                        const { blocks, expand } = element
                        return (
                            renderCondition(index, element, blocks, expand)
                        )
                    })}
                </ReactSortable>
            </div>
        </div >
    )
}
export default Condition